import { z } from 'zod';
import { objectId } from '../ObjectId';

import { chatContext } from './ChatContext';
import { EndpointContract } from '../../architecture/ControllerContract';

const body = z
    .object({
        chatId: objectId,
        context: chatContext
    })
    .strict();

export const updateChatContext = {
    verb: 'post',
    path: 'update-context',
    schema: {
        body,
        response: {
            200: chatContext
        }
    }
} as const satisfies EndpointContract;
export type UpdateChatContext = z.infer<typeof body>;
